import { useQueryState } from 'nuqs';
import { useCallback, useMemo } from 'react';
import { searchParams } from '@/lib/searchparams';

export function useOpportunityFilters() {
  const [searchQuery, setSearchQuery] = useQueryState('q', searchParams.q);
  const [sort, setSort] = useQueryState('sort', searchParams.sort);
  const [status, setStatus] = useQueryState('status', searchParams.status);
  const [page, setPage] = useQueryState('page', searchParams.page);

  const resetFilters = useCallback(() => {
    setSearchQuery(null);
    setSort(null);
    setStatus(null);
    setPage(1);
  }, [setSearchQuery, setSort, setStatus, setPage]);

  const isAnyFilterActive = useMemo(() => {
    return !!searchQuery || !!sort || !!status;
  }, [searchQuery, sort, status]);

  return {
    searchQuery,
    setSearchQuery,
    sort,
    setSort,
    status,
    setStatus,
    page,
    setPage,
    resetFilters,
    isAnyFilterActive
  };
}

